import isEmpty from 'lodash/isEmpty';

import { useIsVoyageProtectionAddOnEnabled } from '@/ducks/addOns/hooks';
import { getSessionStorageValue } from '@/helpers/util';
import { useAppSelector } from '@/store';

import { selectPrimarySailor, selectSecondarySailors } from './selectors';

export const useGetPrimarySailor = () => {
  const isVoyageProtectionAdded = useIsVoyageProtectionAddOnEnabled();
  const reduxPrimarySailor = useAppSelector(selectPrimarySailor);
  const storagePrimarySailor = getSessionStorageValue('primarySailor');

  return isEmpty(reduxPrimarySailor)
    ? storagePrimarySailor
    : {
        ...reduxPrimarySailor,
        insurance: isVoyageProtectionAdded,
      };
};

export const useGetSailorsData = () => {
  const primarySailor = useGetPrimarySailor();
  const additionalSailors = useAppSelector(selectSecondarySailors);

  return {
    additionalSailors,
    primarySailor,
  };
};
